import React, { useState, useEffect } from 'react';
import Verifiers from '../../../../utils/Verifiers.jsx';
import EditarUsuario from './EditarUsuario';
import "../styles/getUsuariosSubseccion.css"
import AsociadorUsuariosExternosNomina from './AsociadorUsuariosExternosNomina.jsx';

const GestionUsuariosSubseccion = (p) => {
    const getData = p.getData ?? (async () => { });
    const keyGen = p.keyGen ?? (() => { });
    const getAPI = p.getAPI ?? (async () => { });
    const seteditUser = p.seteditUser ?? (() => { });
    const setnuevoUsuario = p.setnuevoUsuario ?? (() => { });
    const [data, setdata] = useState({ usuarios: [], perfiles: [] });
    const [originalData, setoriginalData] = useState();
    const [seccionVinculacion, setseccionVinculacion] = useState(false);

    const [filtros, setfiltros] = useState({ perfil: '', search: '' });
    useEffect(() => {
        setdata(p.data);
        setoriginalData(p.data.usuarios);
    }, [p.data]);

    const filtrar = (event) => {
        let { name, value } = event.target;
        let filt = { ...filtros, [name]: value };
        let results = [];
        let len = originalData.length;
        let search = Verifiers.getUniqueWords(filt.search, true);

        for (let i = 0; i < len; i++) {
            if (filt.search !== "") {
                let word = Verifiers.text_normalice(`${originalData[i].nombre} ${originalData[i].perfil_nombre} ${originalData[i].estatus === 1 ? 'activo' : 'cancelado deshabilitado suspendido inactivo'}`, true);
                if (!Verifiers.find(search, word)) continue;
            }
            if (filt.perfil !== "" && originalData[i].perfil != filt.perfil) continue;
            results.push(originalData[i]);
        }
        setdata({ ...data, usuarios: results });
        setfiltros(filt);
    }

    /**
    * Fcunión para reasignar tipo de usuario a un usuario del sistema
    * @param {number} user Número entero mayor a cero, id del usuario a editar
    * @param {numbrer} type id del tipo de usuario que se va a asignar
    * @returns 
    */
    const cambiarTipo = async (user, type) => {
        if (type === "") return;
        let resp = await getAPI("secure/users/change", { usuario: user, type: type });
        if (resp) getData();
    }


    return (
        <>
            <div className='bw-1200 round-s border p-2 pt-0 bg-white blur-xl mt-2 mb-3 overflow relative' style={{ height: "50vh", transition: "height 0.5s" }}>
                <div className='w-100 sticky bg-white4 blur-l pb-2 pt-2' style={{ top: 0, left: 0, zIndex: 2 }}>
                    <div className='grid-6'>
                        <div className='column-filtro m-0 p-0'>
                            <select className='form-control form-control-sm shadow-sm round-xxl border' name='perfil' onChange={filtrar} value={filtros.perfil}>
                                <option value='' >Todos los tipos</option>
                                {data.perfiles.map((perfil, i) => <option key={keyGen()} value={perfil.id} className='round-xxl mb-2' >{perfil.nombre}</option>)}
                            </select>
                        </div>

                        <div className='column-buscar m-0 p-0'>
                            <input type='text' className='form-control form-control-sm shadow-sm round-xxl border' name='search' placeholder='Buscar usuario...' autoComplete='off' onChange={filtrar} value={filtros.search} />
                        </div>
                        <div className='column-nuevo-usuario m-0 p-0'>
                            <button className='btn btn-sm round-xxl border border-warning text-bold w-100 btn-light shadow' onClick={() => setnuevoUsuario({ name: '', password: '', type: '' })} >Agregar usuario</button>
                        </div>
                    </div>
                </div>
                {data.usuarios.map((usuario, index) =>
                    <div className={`w-100 p-1 ps-2  pe-2 round-s mb-3 border bg-light grid-6 ${usuario.estatus ? '' : 'opacity-70'}`} key={keyGen()}>
                        <div className='columna-nombre-usuario border-bottom border-bottom border-info'>
                            <span className='text-xs mr-2'>Nombre:</span>
                            <span className='text-bold me-2'>{usuario.nombre}</span>
                            {usuario.estatus === 0 && <span className='text-m text-red3 text-bold ms-2'>Usuario deshabilitado</span>}
                        </div>
                        <div className='usuario-dato m-0 p-0 '>
                            <div className='w-100 m-0 p-0 text-xs text-bold'>Tipo de perfil</div>
                            <div className='w-100'>{usuario.perfil_nombre}</div>
                        </div>
                        {(usuario.ranchos.length > 0 || usuario.areas.length > 0) &&
                            <div className="usuario-dato m-0 p-0 text-start text-xs">
                                {usuario.ranchos.length > 0 && <div><span className='text-bold me-1'>Rancho(s):</span>
                                    {usuario.ranchos.map((rancho, i) => <span key={rancho.id + "" + usuario.id + "ran"}>{rancho.nombre}{i !== usuario.ranchos.length - 1 ? ', ' : ''}</span>)}
                                </div>}
                                {usuario.areas.length > 0 && <div><span className='text-xs text-bold me-1'>Área(s):</span>
                                    {usuario.areas.map((area, i) => <span key={area.id + "" + usuario.id + "area"}>{area.nombre}{i !== usuario.areas.length - 1 ? ', ' : ''}</span>)}
                                </div>}
                            </div>
                        }

                        <div className='usuario-dato m-0 p-0'>
                            <select className='form-control form-control-sm border shadow-sm' defaultValue={usuario.perfil}
                                disabled={usuario.estatus == 0}
                                onChange={(e) => { cambiarTipo(usuario.id, e.target.value) }}>
                                {data.perfiles.map((perfil, i) => <option value={perfil.id} key={keyGen()} >{perfil.nombre}</option>)}
                            </select>
                        </div>
                        <div className='usuario-dato m-0 p-0'>
                            <button className={`btn btn-sm w-100 btn-light border border-${usuario.vinculacion ? "success text-bold" : "secondary"} border-2 shadow`} onClick={() => setseccionVinculacion(usuario)} >
                                {usuario.vinculacion ? (<><div className='col-lg-12 text-xs text-green3'>Vinculado a Nómina</div> <div className='col-lg-12 text-xxs'>{usuario.vinculacion.nombre}</div></>) : "Vincular usuario"}
                            </button>
                        </div>
                        <div className='usuario-dato m-0 p-0 '>
                            <button className='btn btn-sm w-100 btn-light border border-2 border-warning shadow' onClick={() => seteditUser(usuario)} >Pulse para editar</button>
                        </div>
                    </div>
                )}

            </div>
            {seccionVinculacion && <AsociadorUsuariosExternosNomina close={(refrescar) => { if (refrescar) getData(); setseccionVinculacion(false) }} usuario={seccionVinculacion} />}
        </>
    )
}

export default GestionUsuariosSubseccion;